import React, { useRef, useState } from "react";
import { ManualBox } from "../manualsBox/products-manualsBox";
export const tabList = [
    {idx: 1, title : 'Features'},
    {idx: 2, title : 'Description'},
    {idx: 4, title : 'Specifications'},
    {idx: 5, title : 'Manuals & Firmware'},
]
export const GX1600 = () => {
    const [state, setState] = useState<any>({first : 1, second : 1})
    const [tabIndex, setTabIndex] = useState<number>(1)
    const scrollRef = [
        useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null),
        useRef<any>(null),
        useRef<any>(null),
        useRef<any>(null),
        useRef<any>(null),
        useRef<any>(null)
    ];
    const handleScroll = (ref : number) => {
        if(scrollRef[ref] && scrollRef[ref].current){
            scrollRef[ref].current.scrollIntoView({
                behavior : 'smooth'
            })
        }
    }
    return(
        <>
        <div className="product_view gx1600">
            <div className="bgBox" style={{backgroundImage: "url('/assets/images/product/gx1600/banner_GX1600.jpg')"}}>
                <div className="centerBox">
                    <h2><span>GX</span>1600</h2>
                    <p>KOREAN EAGLE EYE, 4K+QHD & STARVIS 2</p>
                    <ul>
                        <li onClick={() => handleScroll(0)}>UHD/QHD</li>
                        <li onClick={() => handleScroll(1)}>SONY STARVIS SENSOR 2</li>
                        <li onClick={() => handleScroll(2)}>ADAS MAX</li>
                        <li onClick={() => handleScroll(3)}>DUAL HDR</li>
                        <li onClick={() => handleScroll(4)}>SMART TIME LAPSE</li>
                        <li onClick={() => handleScroll(5)}>Auto Night Vision</li>
                        <li onClick={() => handleScroll(6)}>BUILT-IN GPS & BT + WI-FI</li>
                        <li onClick={() => handleScroll(7)}>AI HEAT MONITORING</li>
                        <li onClick={() => handleScroll(8)}>NON-LCD</li>
                        <li onClick={() => handleScroll(9)}>SPEED CAMERA ALERT</li>
                        <li onClick={() => handleScroll(10)}>OW VOLTAGE CUT-OFF</li>
                        <li onClick={() => handleScroll(11)}>FORMAT FREE 2.0</li>
                    </ul>
                </div>

                <div className="scrollDownBox">
                    <div>
                        <span></span>
                    </div>
                    <span>SCROLL</span>
                </div>
            </div>
            {/* <!-- bgBox Fin --> */}

            <div className="tabWrap tabBtnWrapBattery">
                <div className="tabBtnWrap">
                    <div className="tabBtnBox">
                        {tabList.map((list: { idx: number, title: string }) => (

                          <button className={tabIndex === list?.idx ? 'active' : ''} onClick={() => setTabIndex(list?.idx)}>
                              {list?.title}
                          </button>
                        ))}
                    </div>
                </div>
                <div className="tabContentBox">
                    <div className={`features ${tabIndex === 1 ? 'active' : ''}`}>
                        <section className="section_1">
                            <div className="imgBox">
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_01.png" alt="GX1600"/>
                            </div>
                        </section>

                        <section className="section_2">
                            <div className="imgBox">
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_02.png" alt="UHD/QHD"/>
                            </div>
                            <div className="resolution_tableWrap2" style={{marginTop: '30px'}}>
                                <ul>
                                    <li>
                                        <span></span>
                                        <span>FHD</span>
                                        <span>QHD</span>
                                        <span>UHD</span>
                                    </li>
                                    <li>
                                        <span>Resolution</span>
                                        <span>1920 x 1080</span>
                                        <span>2560 x 1440</span>
                                        <span style={{borderBottom: '1px solid #F0800E'}}>3840 x 2160</span>
                                    </li>
                                    <li>
                                        <span>Pixels</span>
                                        <span>2,073,600</span>
                                        <span>3,686,400</span>
                                        <span style={{borderRight: '1px solid #F0800E', borderBottom: '1px solid #F0800E'}}>8,294,400</span>
                                    </li>
                                </ul>
                            </div>
                        </section>

                        <section className="section_3" ref={scrollRef[0]}>
                            <div className="imgBox" style={{marginBottom: '10px'}}>
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_03.png" alt="UHD/QHD"/>
                            </div>
                            <p>*This video was taken in UHD/QHD quality. The license plate was mosaicized to protect personal information.</p>
                            <p>*The quality of recording may vary depending on conditions. (including camera angle, windshield conditions, and light conditions)</p>
                        </section>

                        <section className="section_4" ref={scrollRef[1]}>
                            <h3>
                                <span>Sony Starvis 2 Sensor</span>
                                UPGRADED RECORDING QUALITY EVEN AT NIGHT
                            </h3>
                            <p>Upgraded SONY STARVIS 2 SENSOR reduces power consumption by 30%<br/>
                                compared to SONY STARVIS 1, providing unimaginably vivid image regardless of day or night.</p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_04.png" alt="CLEAR RECORDING EVEN AT NIGHT"/>
                            </div>
                        </section>

                        <section className="section_4" ref={scrollRef[2]}>
                            <h3>
                                <span>ADAS MAX</span>
                                SMART DRIVING WITH ADAS MAX
                            </h3>
                            <p>The GX1600 comes equipped with ADAS(Advanced Driver Assistance System) that<br/>
                                enhance both safety and driving awarness. It offers eight real-time safety alerts - five for the front and three for the rear.</p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_05.png" alt="ADAS MAX"/>
                            </div>
                            <p style={{marginTop: '30px'}}>These inteligent features work seamlessly to help prevent collisions and increase driver awarness of their surroundings.</p>
                        </section>

                        <section className="section_5" ref={scrollRef[3]}>
                            <h3>
                                <span>dual hdr</span>
                                OPTIMIZED WITH HIGH DYNAMIC RANGE(HDR)
                            </h3>
                            <p>Exposure is balanced for keeping all details intact.</p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_06.png" alt="DUAL HDR"/>
                            </div>
                        </section>

                        <section className="section_6" ref={scrollRef[4]}>
                            <h3>
                                <span>smart time-lapse</span>
                                RECORD YOUR DRIVE WITH TIME-LAPSE
                            </h3>
                            <p>
                                SMART TIME-LAPSE feature captures up to 169minutes with no data loss. When an impact is detected.<br/>
                                FineVu will automatically save the footage in 30fps.
                            </p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_07.png" alt="TIME Lapse"/>
                            </div>
                            <ul style={{marginTop: '16px'}}>
                                <li>* SMART TIME-LAPSE Specifications were measured under 32GB and compared to the default driving mode.</li>
                                <li>* Factors such as collision events may affect the storage volume.</li>
                            </ul>
                        </section>

                        <section className="section_7" ref={scrollRef[5]}>
                            <h3>
                                <span>Auto Night Vision</span>
                                AUTOMATED NIGHT VISION ADJUSTS<br/>
                                BRIGHTNESS AND CONTRAST TO SECURE CLARITY
                            </h3>
                            <p>Smart AI system assesses light environment and finds the perfect time to switch it on,<br/>
                                Keeping you completely hand-free.</p>
                            <div className="slide_tabBtnWrap">
                                <div className={`slide_tabBtnBox number2 active_${state.second}`}>
                                    <button onClick={() => setState((prev: any) => ({...prev, second: 1}))}>
                                        <span>NIGHT</span>
                                    </button>
                                    <button onClick={() => setState((prev: any) => ({...prev, second: 2}))}>
                                        <span>DAY</span>
                                    </button>
                                </div>
                            </div>

                            <div className="tabContentBox">
                                <div className={state.second === 1 ? 'active' : ''}>
                                    <div className="imgBox">
                                        <img src="/assets/images/product/gx1600/FineVu_GX1600_08.png" alt="night"/>
                                    </div>
                                </div>
                                <div className={state.second === 2 ? 'active' : ''}>
                                    <div className="imgBox">
                                        <img src="/assets/images/product/gx1600/FineVu_GX1600_09.png" alt="day"/>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section className="section_8" ref={scrollRef[6]}>
                            <h3>
                                <span>built-in gps</span>
                                WITHOUT THE BURDEN OF PURCHASING<br/>
                                ADDITIONAL EXTERNAL GPS
                            </h3>
                            <p>
                                Feel free to use functions such as speed camera alert and adas plus.
                            </p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_10.png" alt="built-in gps"/>
                            </div>
                            <div className="imgBox" style={{marginTop: '120px'}}>
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_11.png" alt="built-in gps"/>
                            </div>
                        </section>

                        <section className="section_9">
                            <h3>
                                <span>built-in bt + WI-FI</span>
                                SEAMLESSLY CONNECT TO<br/>
                                YOUR SMARTPHONE ON THE FIRST TRY
                            </h3>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_12.png" alt="built-in bt + WI-FI"/>
                            </div>
                            <ul>
                                <li>* If the connection fails, please allow all FineVU CLOUD & Wi-Fi app permissions.</li>
                            </ul>
                        </section>

                        <div className="resolution_tableWrap">
                            <ul>
                                <li>
                                    <span></span>
                                    <span>Wi-Fi</span>
                                    <span>BT + Wi-Fi</span>
                                </li>
                                <li>
                                    <span>DAY 1<br/><span style={{fontSize: '14px', color: '#666'}}>First Connection</span></span>
                                    <span><img src="/assets/images/product/gx1600/FineVu_GX1600_13.png" alt="WI-FI"/></span>
                                    <span style={{borderBottom: '1px solid #F0800E'}}><img src="/assets/images/product/gx1600/FineVu_GX1600_14.png" alt="built-in bt + WI-FI"/></span>
                                </li>
                                <li>
                                    <span>DAY 2</span>
                                    <span><img src="/assets/images/product/gx1600/FineVu_GX1600_15.png" alt="WI-FI"/></span>
                                    <span style={{borderRight: '1px solid #F0800E', borderBottom: '1px solid #F0800E'}}><img src="/assets/images/product/gx1600/FineVu_GX1600_16.png" alt="built-in bt + WI-FI"/></span>
                                </li>
                                <li>
                                    <span>DAY 3</span>
                                    <span><img src="/assets/images/product/gx1600/FineVu_GX1600_17.png" alt="WI-FI"/></span>
                                    <span><img src="/assets/images/product/gx1600/FineVu_GX1600_18.png" alt="built-in bt + WI-FI"/></span>
                                </li>
                            </ul>
                        </div>

                        <section className="section_10">
                            <h3>
                                CHECK THE RECORDED VIDEOS AND UPDATE<br/>
                                THE FIRMWARE ON FINEVE APP.
                            </h3>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_19.png" alt="APP"/>
                            </div>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_39.png" alt="APP QR Code"/>
                            </div>
                        </section>

                        <section className="section_11" ref={scrollRef[7]}>
                            <h3>
                                <span>Ai heat monitoring</span>
                                SMART AI DASHCAM CONTROL
                            </h3>
                            <p>If FineVu starts to overheat while at parking mode, AI automatically powers off the dashcam.</p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_21.png" alt="Ai heat monitoring"/>
                            </div>
                            <ul style={{marginTop: '30px'}}>
                                <li>*The feature is only applicable druing motion/time lapse parking mode.</li>
                                <li>*After system cut-off, the terminal remains OFF until the ignition is turned ON.</li>
                            </ul>
                        </section>


                        <section className="section_12" ref={scrollRef[8]}>
                            <h3>
                                <span>NON-LCD</span>
                                UNOBSTRUCTED VIEW,<br/>
                                READY FOR ANY ROAD
                            </h3>
                            <p>FineVu Dash cams easily mount anywhere without blocking your rearview mirror.<br/>
                                Quick and simple installation in the perfect position for you.</p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_22.png" alt="TIME Lapse"/>
                            </div>
                        </section>

                        <section className="section_13" ref={scrollRef[9]}>
                            <h3>
                                <span>speed camera alert</span>
                                FINEVU KEEPS UP WITH THE<br/>
                                LATEST SAFETY CAMERA ALERT
                            </h3>
                            <p>FineVu safety camera database is always up to date. Download the quarterly updates,<br/>
                                and get informed with FineVu’s voice alerts.<br/>
                                Worry no more about accidents and speeding tickets.</p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_23.png" alt="TIME Lapse"/>
                            </div>
                            <ul style={{marginTop: '16px'}}>
                                <li>* Database is updated quarterly.</li>
                            </ul>
                        </section>

                        <section className="section_14" ref={scrollRef[10]}>
                            <h3>
                                <span>low voltage cut-off</span>
                                BATTERY PROTECTION INTEGRATED
                            </h3>
                            <p>FineVu is equipped with Battery Protection System.<br/>
                                Dashcam powers down when battery voltage falls below preset value.<br/>
                                Select your-car-specific power setting on FineVu CLOUD & Wi-Fi app to maximize both dashcam and car battery with a single tap.</p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_24.png" alt="TIME Lapse"/>
                            </div>
                            <ul style={{marginTop: '16px'}}>
                                <li>* FineVu recommends changing the low voltage settings to ‘hybrid’ when using the ISG system.</li>
                            </ul>
                        </section>

                        <section className="section_14" ref={scrollRef[11]}>
                            <h3>
                                <span>FORMAT FREE 2.0</span>
                                ADVANCED FORMAT FREE TECHNOLOGY
                            </h3>
                            <p>Format Free 2.0 technology eliminates the needs of manual reformatting the micro SD memory card.<br/>
                                Also, it helps to extend memory card lifetime and improve reliability.</p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_25.png" alt="FORMAT FREE 2.0"/>
                            </div>
                        </section>

                        <section className="section_15">
                            <h3>
                                <span>CUSTOMIZING OSD PHRASES</span>
                                SYMBOLIC NAME ACCORDING TO USER’S TASTE
                            </h3>
                            <p>Users can change the wording of the On Screen Display(OSD) to user’s preference.<br/>
                                Up to 20 characters can be entered in English letters and numbers.</p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_26.png" alt="CUSTOMIZING OSD PHRASES"/>
                            </div>
                            <ul style={{marginTop: '16px'}}>
                                <li>* OSD Phrases can be set up in the FineVu CLOUD & Wi-Fi app.</li>
                            </ul>
                        </section>

                        <section className="section_16">
                            <h3>
                                <span>FINEVU PC PLAYER</span>
                                THE OPTIMAL DASH CAM ANALYSIS PROGRAM,<br/>
                                FINEVU PLAYER 2.0
                            </h3>
                            <p>FineVu PC player is an easy-to-use PC software for FineVu dash cam.<br/>
                                You can playback, screenshot, enlarge the images with full resolution and<br/>
                                monitor the video records conveniently on your PC.</p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_27.png" alt="FINEVU PC PLAYER"/>
                            </div>
                            <ul style={{marginTop: '16px'}}>
                                <li>* This feature can be used after installing FineVu Player program.</li>
                            </ul>
                        </section>
                    </div>
                    <div className={`whatsInTheBox ${tabIndex === 2 ? 'active' : ''}`}>
                        <section>

                            <div className="imgBox">
                                <h3>Product Description</h3>
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_28.png" alt="Product Description"/>
                            </div>
                            <div className="imgBox">
                                <h3>WHAT’S IN THE BOX</h3>
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_29.png" alt="Product Description"/>
                            </div>
                            <ul style={{marginBottom: '100px'}}>
                                <li>※ To improve the performance of the product, its components may change without prior notice.</li>
                                <li>※ The warranty period of the Micro SD card is 6 months.</li>
                            </ul>
                            <div className="imgBox">
                                <h3>OPTIONAL ACCESSORIES</h3>
                                <img src="/assets/images/product/gx1600/FineVu_GX1600_30.png" alt="Product Description"/>
                            </div>
                        </section>
                    </div>

                    <div className={`specifications ${tabIndex === 4 ? 'active' : ''}`}>
                        <div className="tableWrap">
                            <table>
                                <thead>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th>FineVu GX1600</th>
                                    <th>Remark</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                <th rowSpan={2}>Image Sensor</th>
                                    <td>
                                        Front : 8M pixels CMOS Image Sensor (1/1.8”)
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>
                                        Rear : 5M pixels CMOS Image Sensor (1/2.8”)
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Resolution</th>
                                    <td>
                                        3840*2160P(Ultra HD) / 2560*1440P(Quad HD)
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Frames Per Second</th>
                                    <td>
                                        Driving : 30fps, Smart Time Lapse 6fps<br/>
                                        Parking : 30fps, Smart Time Lapse 2fps
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Viewing Angle</th>
                                    <td>
                                        Front : 146°<br></br>
                                        Rear : 135°
                                    </td>
                                    <td>Diagonal</td>
                                </tr>
                                <tr>
                                    <th>Recording Mode</th>
                                    <td>
                                        Driving Recording (Standard, Impact Detection, Smart Time Lapse), Manual Recording, Parking Recording (Motion Detection, Impact Detection, Smart Time Lapse)
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Display</th>
                                    <td>Non-LCD</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Acceleration Sensor</th>
                                    <td>3-axis acceleration sensor</td>
                                    <td>+2g / -2g</td>
                                </tr>
                                <tr>
                                    <th>GPS</th>
                                    <td>Built-in</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Wi-Fi</th>
                                    <td>Built-in(Dongle)</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Storage Capacity</th>
                                    <td>FineVu Micro SD Card (64GB ~ 256GB)</td>
                                    <td>Class 10 or above, SDXC support</td>
                                </tr>
                                <tr>
                                    <th>Battery</th>
                                    <td>Super Capacitor</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>MIC</th>
                                    <td>Built-In</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Speaker</th>
                                    <td>Built-In</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Interface</th>
                                    <td>
                                        Power port, Rear camera connection port, Micro SD card slot, Button (REC/MIC, Wi-Fi), Security LED, Status LED, Speaker
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Security LED</th>
                                    <td>
                                        Front : White / Rear : White
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Input Power</th>
                                    <td>DC 12V~24V</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Power Consumption</th>
                                    <td>
                                        Parking Mode : 4.8W
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>High-Temperature Cut-Off</th>
                                    <td>AI Heat Monitoring</td>
                                    <td>During parking mode</td>
                                </tr>
                                <tr>
                                    <th>Low Voltage Cut-Off</th>
                                    <td>Supported</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Temperature</th>
                                    <td>
                                        Operation : -10°C ~ 60°C (14°F ~ 140°F)<br/>
                                        Storage : -20°C ~ 70°C (-4°F ~158°F)
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Size(WxDxH)</th>
                                    <td>
                                        Front : 119 x 62 x 32mm (4.7” x 2.4” x 1.3”)<br/>
                                        Rear : 63.7 x 29 x 35.5mm (2.5” x 1.1” x 1.4”)
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Weight</th>
                                    <td>
                                        Front : 172g (6.0oz)<br/>
                                        Rear : 36g (1.2oz)
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Language Supported</th>
                                    <td>English, Chinese(Simplified, Traditional), French, German, Arabic, Hebrew, Japanese, Malay, Polish, Russian, Spanish, Thai, Turkish, Vietnamese, Korean</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Mobile Application</th>
                                    <td>FineVu CLOUD & Wi-Fi App</td>
                                    <td>Android, iOS</td>
                                </tr>
                                <tr>
                                    <th>PC Viewer</th>
                                    <td>FineVu Player 2.0</td>
                                    <td>Windows, MAC</td>
                                </tr>
                                <tr>
                                    <th>Features</th>
                                    <td>
                                        HDR, Auto Night Vision, AI Heat Monitoring, Smart Time Lapse, ADAS MAX (FVMA, FCWS, LDWS, PCWS, uFCWS, BSD(R), BSD(L),RCWS), Speed Camera Alert, Low Voltage Cut-off
                                    </td>
                                    <td>ADAS and Speed Camera Alert requires GPS reception</td>
                                </tr>
                                <tr>
                                    <th>Certification</th>
                                    <td className="imgArea">
                                        <div>
                                            <img src="/assets/images/table_certification.png" alt="Certification"/>
                                        </div>
                                    </td>
                                    <td></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {tabIndex === 5 ? <ManualBox/> : ''}
                </div>
            </div>
        </div>

        </>
    )
}
